export const Tabs = {
	SURVEY_TEMPLATE: 'SURVEY_TEMPLATE',
	INVITE: 'INVITE',
	PEOPLE: 'PEOPLE',
	REPORT: 'REPORT',
};
